/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Meta_Free_SubtitleInputs */



/**
* | output |
* | --- |
* | "Explore on your own" |
*
* @param {Plan_Meta_Free_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_meta_free_subtitle = /** @type {((inputs?: Plan_Meta_Free_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Meta_Free_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entdecken Sie auf eigene Faust")
	return /** @type {LocalizedString} */ ("Explore on your own")
});